export enum BroadcastUrlTypes {
  TV = 'tv-products',
  RADIO = 'radio-products',
}

export interface BroadcastRouteParams {
  broadcastType: BroadcastUrlTypes;
}
